"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Utils = __importStar(require("./gl-utils/utils"));
var fbo_1 = __importDefault(require("./gl-utils/fbo"));
var Parameters = __importStar(require("./parameters"));
var brush_1 = __importDefault(require("./brush"));
var obstacle_map_1 = __importDefault(require("./obstacle-map"));
var fluid_1 = __importDefault(require("./fluid"));
var Requirements = __importStar(require("./requirements"));
require("./page-interface-generated");
function initGL(canvas, flags) {
    function setError(message) {
        Page.Demopage.setErrorMessage("webgl-support", message);
    }
    var gl = canvas.getContext("webgl", flags);
    if (!gl) {
        gl = canvas.getContext("experimental-webgl", flags);
        if (!gl) {
            setError("Your browser or device does not seem to support WebGL.");
            return null;
        }
        setError("Your browser or device only supports experimental WebGL.\n" +
            "The simulation may not run as expected.");
    }
    if (gl) {
        canvas.style.cursor = "none";
        gl.disable(gl.CULL_FACE);
        gl.disable(gl.DEPTH_TEST);
        gl.disable(gl.BLEND);
        gl.clearColor(0.0, 0.0, 0.0, 1.0);
        Utils.resizeCanvas(gl, false);
    }
    return gl;
}
function main() {
    var canvas = Page.Canvas.getCanvas();
    var gl = initGL(canvas, { alpha: false });
    if (!gl || !Requirements.check(gl))
        return;
    var extensions = [
        "OES_texture_float",
        "WEBGL_color_buffer_float",
        "OES_texture_float_linear",
    ];
    Requirements.loadExtensions(gl, extensions);
    var size = 256;
    var fluid = new fluid_1.default(gl, size, size);
    var brush = new brush_1.default(gl);
    var obstacleMaps = [];
    obstacleMaps["none"] = new obstacle_map_1.default(gl, size, size);
    obstacleMaps["one"] = new obstacle_map_1.default(gl, size, size);
    {
        obstacleMaps["one"].addObstacle([0.015, 0.015], [0.3, 0.5]);
    }
    obstacleMaps["many"] = new obstacle_map_1.default(gl, size, size);
    {
        var size_1 = [0.012, 0.012];
        for (var iX = 0; iX < 5; ++iX) {
            for (var iY = -iX / 2; iY <= iX / 2; ++iY) {
                size_1 = [size_1[0] + 0.0005, size_1[1] + 0.0005];
                var pos = [0.3 + iX * 0.07, 0.5 + iY * 0.08];
                obstacleMaps["many"].addObstacle(size_1, pos);
            }
        }
    }
    Parameters.bind(fluid);
    var instantFPS = 0;
    var updateFpsText = function () {
        Page.Canvas.setIndicatorText("fps", instantFPS.toFixed(0));
    };
    setInterval(updateFpsText, 1000);
    var lastUpdate = 0;
    function mainLoop(time) {
        time *= 0.001;
        var dt = time - lastUpdate;
        instantFPS = 1 / dt;
        lastUpdate = time;
        dt = Math.min(dt, 1 / 10);
        var obstacleMap = obstacleMaps[Parameters.obstacles];
        if (Parameters.fluid.stream) {
            fluid.addVel([0.1, 0.5], [0.05, 0.2], [0.4, 0]);
        }
        fluid.update(obstacleMap);
        fbo_1.default.bindDefault(gl);
        gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
        if (Parameters.display.velocity) {
            fluid.drawVelocity();
        }
        else if (Parameters.display.pressure) {
            fluid.drawPressure();
        }
        if (Parameters.display.brush) {
            brush.draw();
        }
        if (Parameters.display.obstacles) {
            obstacleMap.draw();
        }
        if (Parameters.display.velocity && Parameters.display.pressure) {
            gl.viewport(10, 10, 128, 128);
            fluid.drawPressure();
        }
        requestAnimationFrame(mainLoop);
    }
    requestAnimationFrame(mainLoop);
}
main();
